import AppRecord from './AppRecord.js'
class Document extends AppRecord {
  get data_updated_days_ago(){
    let cre = Date.parse(this.data_updated_at)
    let now = Date.now()
    return (now-cre)/1000/60/60/24
  }
  get data_updated_days_ago_string(){
    return this.daysAgoToString(this.data_updated_days_ago)
  }
  get attached(){
    return this['attached?']
  }
  get owner(){
    if(this.owner_type === 'Issue'){
      return this.constructor.employeeStore.issues.find(isx => isx.id === this.owner_id)
    } else if(this.owner_type === 'Entity'){
      return this.constructor.employeeStore.entitiesById.get(this.owner_id)
    } else if(this.owner_type === 'Deposit'){
      return this.constructor.employeeStore.deposits.find(isx => isx.id === this.owner_id)
    } else if(this.owner_type === 'Person'){
      return this.constructor.employeeStore.peopleById.get(this.owner_id)
    } else if(this.owner_type === 'Account'){
      return this.constructor.employeeStore.accountsById.get(this.owner_id)
    } else {
      return undefined
    }
  }
  get owner_name(){
    if(this.owner && this.owner.name){
      return this.owner.name
    } else {
      return undefined
    }
  }
  get document_privileges(){
    return this.constructor.employeeStore.document_privileges.filter(priv => priv.document_id === this.id)
  }
  get document_relations(){
    return this.constructor.employeeStore.document_relations.filter(priv => priv.document_id === this.id)
  }
  get current_user(){
    return this.constructor.employeeStore.current_user
  }
  get canEdit(){
    if(!this.id){
      return true
    }
    return Boolean(this.document_privileges.find(priv => priv.write && (priv.user_id === this.constructor.employeeStore.current_user.id || this.constructor.employeeStore.current_user.roles.includes(priv.role) )))
  }
  get canDestroy(){
    return Boolean(this.document_privileges.find(priv => priv.purge && (priv.user_id === this.constructor.employeeStore.current_user.id || this.constructor.employeeStore.current_user.roles.includes(priv.role) )))
  }
  get canPurge(){
    return this.canDestroy
  }
  get canGrant(){
    let grants = this.document_privileges.filter(priv => priv.grant)
    let roles = grants.map(priv => priv.role)
    let usrs = grants.map(priv => priv.user_id)
    return usrs.includes(this.constructor.employeeStore.current_user.id) || roles.find(rr => this.constructor.employeeStore.current_user.roles.includes(rr))
  }
  get cantGrant(){
    return !this.canGrant
  }
  set document_privileges(items){
    this.setRelatedData(items, 'DocumentPrivilegesController')
  }
  set document_relations(items){
    this.setRelatedData(items, 'DocumentRelationsController')
  }
  get group(){
    if(this.group_id){
      return this.constructor.employeeStore.document_groups.find(gr => gr.id === this.group_id)
    } else {
      return {}
    }
  }
  get group_nested_title(){
    if (this.group && this.group.nested_title){
      return this.group.nested_title
    } else {
      return ''
    }
  }
}
export default Document
